"use strict";
// generated-loan-tape.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = exports.SignaledAssignmentValueMappingSchema = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const tasks_1 = require("../../tasks");
exports.SignaledAssignmentValueMappingSchema = zod_1.z.object({
    creditFacilitySlug: zod_1.z
        .string()
        .describe('Specifies the credit facility that will be assigned to the receivable when the fieldValue is matched'),
    fieldValue: zod_1.z
        .string()
        .describe('Determines the value for externalAssignmentField that will trigger the assignment'),
});
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: zod_1.z.string().nullable().describe('Credit facility slug'),
    loanProductSlug: zod_1.z.string().describe('Loan product slug'),
    externalReceivableId: zod_1.z
        .string()
        .describe('Specifies the field in the sanitized tape that identifies the receivable'),
    rawMasterLoanTapeArtifactSlug: zod_1.z
        .string()
        .nullable()
        .describe('Specifies the artifact slug of the raw loan tape'),
    rawExternalReceivableIdField: zod_1.z
        .string()
        .nullable()
        .describe('Specifies the field in the raw tape that identifies the receivable'),
    loanTapeType: finley_types_1.LoanProduct.LoanTapeTypeSchema.describe('Generated loan tape type, preassignedLoanTape | preassignedMasterLoanTape | masterLoanTape'),
    externalAssignmentField: zod_1.z
        .string()
        .nullable()
        .describe('Specifies the field in the sanitized tape that will be used to determine the assignments. Should be set to null if this is not a preassigned master tape'),
    signaledAssignmentValueMapping: zod_1.z
        .array(exports.SignaledAssignmentValueMappingSchema)
        .optional()
        .describe('For preassigned master tapes this array need to be set to determine signaled assignment for credit facilities.'),
});
exports.nodeType = 'file_generatedLoanTape';
exports.IntermediateRecordConfigSchema = tasks_1.TapeBuilderTaskSchema.and(exports.UIConfigSchema.omit({
    artifactSlug: true,
    creditFacilitySlug: true,
    loanProductSlug: true,
}));
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'generatedLoanTape';
//# sourceMappingURL=types.js.map